<template>
  <div></div>
</template>

<script>
export default {
  name: 'sidebar-footer',
};
</script>
